if (!customElements.get('cbm-customer-photos')) {
  customElements.define(
    'cbm-customer-photos',
    class CustomerPhotos extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-cphoto-track]');
        this.prev = this.querySelector('[data-cphoto-prev]');
        this.next = this.querySelector('[data-cphoto-next]');
        this.dialog = this.querySelector('[data-cphoto-dialog]');
        this.slides = Array.from(this.querySelectorAll('[data-cphoto-slide]'));
        this.count = this.querySelector('[data-cphoto-count]');
        this.current = 0;

        this.onScroll = () => this.updateArrows();
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.prev?.addEventListener('click', () => this.scrollByPage(-1));
        this.next?.addEventListener('click', () => this.scrollByPage(1));

        this.resizeObserver = new ResizeObserver(() => this.updateArrows());
        this.resizeObserver.observe(this.track);

        this.mobile = window.matchMedia('(max-width: 749px)');

        this.addEventListener('click', (event) => {
          const opener = event.target.closest('[data-cphoto-open]');
          if (opener && !this.mobile.matches) this.open(Number(opener.dataset.cphotoOpen));
          const step = event.target.closest('[data-cphoto-step]');
          if (step) this.show(this.current + Number(step.dataset.cphotoStep));
          if (event.target.closest('[data-cphoto-close]')) this.close();
        });

        if (this.dialog) {
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.close();
          });
          this.dialog.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowRight') this.show(this.current + 1);
            if (event.key === 'ArrowLeft') this.show(this.current - 1);
          });
          this.dialog.addEventListener('close', () => {
            document.body.style.overflow = '';
            this.opener?.focus();
          });
        }

        this.updateArrows();
        this.setupLoop();
      }

      setupLoop() {
        const items = Array.from(this.track.children);
        if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        items.forEach((item) => {
          const clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.classList.add('cphoto__item--clone');
          clone.querySelectorAll('button, a').forEach((el) => el.setAttribute('tabindex', '-1'));
          this.track.appendChild(clone);
        });
        this.firstClone = this.track.children[items.length];

        this.track.addEventListener(
          'scroll',
          () => {
            if (!this.mobile.matches) return;
            const loopWidth = this.firstClone.offsetLeft - this.track.firstElementChild.offsetLeft;
            if (this.track.scrollLeft >= loopWidth) {
              this.track.style.scrollBehavior = 'auto';
              this.track.scrollLeft -= loopWidth;
              this.track.style.scrollBehavior = '';
            }
          },
          { passive: true }
        );

        const pause = () => {
          this.paused = true;
          clearTimeout(this.resumeTimer);
        };
        const resume = () => {
          clearTimeout(this.resumeTimer);
          this.resumeTimer = setTimeout(() => (this.paused = false), 2500);
        };
        this.track.addEventListener('touchstart', pause, { passive: true });
        this.track.addEventListener('touchend', resume, { passive: true });

        let position = this.track.scrollLeft;
        let last = 0;
        const tick = (now) => {
          const delta = last ? Math.min(now - last, 50) : 0;
          last = now;
          if (this.mobile.matches && !this.paused) {
            if (Math.abs(this.track.scrollLeft - position) > 2) position = this.track.scrollLeft;
            position += delta * 0.04;
            this.track.scrollLeft = position;
          }
          this.frame = requestAnimationFrame(tick);
        };
        this.frame = requestAnimationFrame(tick);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearTimeout(this.resumeTimer);
        this.resizeObserver?.disconnect();
        document.body.style.overflow = '';
      }

      updateArrows() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.classList.toggle('is-static', max <= 2);
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max - 2;
      }

      scrollByPage(direction) {
        this.track.scrollBy({ left: direction * this.track.clientWidth * 0.8, behavior: 'smooth' });
      }

      open(index) {
        if (!this.dialog || !this.slides.length) return;
        this.opener = document.activeElement;
        this.show(index);
        document.body.style.overflow = 'hidden';
        this.dialog.showModal();
        this.dialog.querySelector('[data-cphoto-close]')?.focus();
      }

      close() {
        this.dialog?.close();
      }

      show(index) {
        const total = this.slides.length;
        this.current = (index + total) % total;
        this.slides.forEach((slide, i) => (slide.hidden = i !== this.current));
        if (this.count) this.count.textContent = `${this.current + 1} / ${total}`;
      }
    }
  );
}
